/** Public attack geometry, shared by authoritative hit tests and client warnings. */
export interface BonecallerAttack {
    id: number
    kind: "spike" | "sweep"
    phase: "anticipation" | "windup" | "impact" | "recovery"
    x: number
    y: number
    angle: number
    radius: number
    halfArc: number
    durationMs: number
    remainingMs: number
}

export interface BonecallerRitual {
    phase: "active" | "interrupted" | "completed"
    /** Lit stone count, retained during the terminal fade. */
    stage: 0 | 1 | 2 | 3
    /** Age of the terminal transition; joining later must not replay the burst. */
    transitionAgeMs?: number
}

export const BONECALLER_COMBAT_RADIUS = 192
export const BONECALLER_STONE_OFFSETS = [{ x: -64, y: -32 }, { x: 0, y: -64 }, { x: 64, y: -32 }]
export const BONECALLER_SPIKE_RADIUS = 42
export const BONECALLER_SWEEP_RADIUS = 80
export const BONECALLER_SWEEP_HALF_ARC = Math.PI / 3

export const bonecallerAttackContains = (attack: Pick<BonecallerAttack,
    "kind" | "x" | "y" | "angle" | "radius" | "halfArc">, point: { x: number; y: number }) => {
    const dx = point.x - attack.x, dy = point.y - attack.y
    if (Math.hypot(dx, dy) > attack.radius) return false
    if (attack.kind === "spike" || (dx === 0 && dy === 0)) return true
    const delta = Math.atan2(Math.sin(Math.atan2(dy, dx) - attack.angle),
        Math.cos(Math.atan2(dy, dx) - attack.angle))
    return Math.abs(delta) <= attack.halfArc
}
